import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { routineItemOptionInsUpdSlice, selectRoutineItemOptionInsUpd } from "../../../redux/routine/routineItemOptionInsUpdSlice";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";
import { colorName } from "../../../redux/routine/routine";

export function RoutineItemOptionInsUpdData() {
    const routineItemOptionInsUpd = useSelector(selectRoutineItemOptionInsUpd);
    const dispatch = useAppDispatch();

    const changedName = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.debug("changed routine item option name", event.target.value);
        event.preventDefault();
        const routineItemOption = {
            ...routineItemOptionInsUpd.routineItemOption
        };
        routineItemOption.name = event.target.value;
        dispatch(routineItemOptionInsUpdSlice.actions.set(routineItemOption));
    };

    const changedOrder = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.debug("changed routine item option order", event.target.value);
        event.preventDefault();
        const routineItemOption = {
            ...routineItemOptionInsUpd.routineItemOption
        };
        routineItemOption.order = parseInt(event.target.value);
        dispatch(routineItemOptionInsUpdSlice.actions.set(routineItemOption));
    };

    const changedColor = (event: SelectChangeEvent) => {
        console.debug("changed routine item option color", event.target.value);
        event.preventDefault();
        const routineItemOption = {
            ...routineItemOptionInsUpd.routineItemOption
        };
        routineItemOption.color = parseInt(event.target.value as string);
        dispatch(routineItemOptionInsUpdSlice.actions.set(routineItemOption));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da opção
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={routineItemOptionInsUpd.routineItemOption.name}
                    onChange={changedName} />
            </Grid>
            <Grid size={6}>
                <TextField required id="order" name="ordem" label="Ordem"
                    fullWidth autoComplete="nome" variant="standard"
                    value={routineItemOptionInsUpd.routineItemOption.order}
                    onChange={changedOrder} />
            </Grid>
            <Grid size={6}>
                <FormControl fullWidth>
                    <InputLabel id="color-label">Cor</InputLabel>
                    <Select
                        labelId="color-label"
                        id="color-select"
                        value={`${routineItemOptionInsUpd.routineItemOption.color || 0}`}
                        label="Cor"
                        onChange={changedColor}
                    >
                        <MenuItem value={0}>{colorName(0)}</MenuItem>
                        <MenuItem value={1}>{colorName(1)}</MenuItem>
                        <MenuItem value={2}>{colorName(2)}</MenuItem>
                        <MenuItem value={3}>{colorName(3)}</MenuItem>
                        <MenuItem value={4}>{colorName(4)}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={12}>
                <AvatarUploadDragAndDrop
                    value={routineItemOptionInsUpd.routineItemOption.url || ""}
                    onChange={(img: string) => {
                        const routineItemOption = {
                            ...routineItemOptionInsUpd.routineItemOption,
                            url: img
                        };
                        dispatch(routineItemOptionInsUpdSlice.actions.set(routineItemOption));
                    }}
                    alt={routineItemOptionInsUpd.routineItemOption.name}
                />
            </Grid>
        </Grid>
        </>;
}